import { db } from '@/data/firebase/config';
import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import { CollectionBase } from '@/domain/types/collections';
import { useAdminLogger } from '@/domain/use-cases/admin-logger';
import FormAddDocument from '@/presentation/components/form-add-document';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const PolicyAddPage = () => {
  const navigate = useNavigate();
  const { logCreate } = useAdminLogger();

  const handleSave = async (data: CollectionBase) => {
    try {
      const docRef = await addDoc(collection(db, DOCUMENTS_DB.POLICIES), {
        ...data,
        createdAt: serverTimestamp(),
      });

      // Log the action
      await logCreate(DOCUMENTS_DB.POLICIES, docRef.id, data.title, data);

      toast.success('Documento guardado correctamente', {
        theme: 'colored',
      });
      navigate('/dashboard/policies');
    } catch (error) {
      toast.error('Error al guardar el documento', {
        theme: 'colored',
      });
      // Re-thrown so FormAddDocument knows the save failed and keeps the
      // autosaved draft instead of deleting the user's only remaining copy.
      throw error;
    }
  };

  return (
    <div className="p-4 flex flex-col gap-4 ">
      <h1 className="text-3xl font-bold">Agregar Política</h1>
      <FormAddDocument onSave={handleSave} />
    </div>
  );
};

export default PolicyAddPage;
